import './search.scss';

const COMPONENT_NAME = 'search';

const BEM = {
  BLOCK: COMPONENT_NAME,
  ELEMENT_FORM: 'search__form',
  ELEMENT_SUBMIT: 'search__submit',
  ELEMENT_FIELD: 'search__form__field',
  ELEMENT_RESET: 'search__form__reset',
  ELEMENT_INPUT: 'search__form__input',
  ELEMENT_CLOSE: 'search__close__button',
  ELEMENT_BACKDROP: 'search__backdrop',
  MODIFIER_OPEN: 'search--open',
  MODIFIER_FIELD_EMPTY: 'search__form__field--empty',
};

/**
 * version    1.0
 * class      <type> (Search)
 * classdesc  Component that manage the header search dropdown
 */
export class Search {
  constructor() {
    const self = this;

    self._vars = {};

    // find elements
    self._els = {};
    self._els.body = $('body');
    self._els.block = $(`.${BEM.BLOCK}`);
    self._els.form = self._els.block.find(`.${BEM.ELEMENT_FORM}`);
    self._els.submitButton = self._els.block.find(`.${BEM.ELEMENT_SUBMIT}`);
    self._els.field = self._els.block.find(`.${BEM.ELEMENT_FIELD}`);
    self._els.reset = self._els.block.find(`.${BEM.ELEMENT_RESET}`);
    self._els.input = self._els.block.find(`.${BEM.ELEMENT_INPUT}`);

    self._initListeners();
  }

  // PRIVATE METHODS

  _initListeners() {
    const self = this;

    $('.header__search').on('click keydown', (event) => {
      if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
        // open the search dropdown
        self._els.block.addClass(BEM.MODIFIER_OPEN);
        self._els.input.trigger('focus');
        self._els.body.addClass('header-open-search');
      }
    });

    function keypressInput(e) {
      const searchValue = this.value;
      const code = (e.keyCode ? e.keyCode : e.which);
      if (code === 13) {
        e.preventDefault();
        const searchUrl = self._els.form.data('search-url');
        const inputText = searchValue;
        window.location.replace(searchUrl + inputText);
      }
    }

    self._els.input.bind('keypress', {}, keypressInput);


    self._els.reset.on('click', () => {
      self._els.field.addClass(BEM.MODIFIER_FIELD_EMPTY);
      self._els.input.val('').trigger('input');
    });

    $(document).on('click', `.${BEM.ELEMENT_CLOSE}, body:not(".search"):not(".header__search")`, (event) => {
      const $target = $(event.target);
      if ($target.closest('.header__search').length > 0) {
        event.stopPropagation();
      } else if (
        ($target.closest('.search').length > 0)
        && !$target.parent().is(`.${BEM.ELEMENT_CLOSE}`)
        && !$target.is(`.${BEM.ELEMENT_BACKDROP}`)
      ) {
        event.stopPropagation();
      } else {
        // close the search dropdown
        self._els.input.val('').trigger('input');
        self._els.block.removeClass(BEM.MODIFIER_OPEN);
        $('body').removeClass('header-open-search');
      }
    });

    $(document).on('keydown', `.${BEM.ELEMENT_CLOSE}`, () => {
      // close the search dropdown
      self._els.input.val('').trigger('input');
      self._els.block.removeClass(BEM.MODIFIER_OPEN);
      $('body').removeClass('header-open-search');
    });

    this._els.submitButton.on('click', (e) => {
      e.preventDefault();
      const searchUrl = self._els.form.data('search-url');
      const inputText = this._els.input.val();
      window.location.replace(searchUrl + inputText);
    });
  }

  _handleAutocompleteInput(rawValue) {
    const self = this;
    const query = rawValue.trim();
    self._els.field.toggleClass(BEM.MODIFIER_FIELD_EMPTY, query.length === 0);
  }
}
